import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EegEnergyProducer } from '../../entities/regep-eeg-energy-producer';
import { FormGroup, NgForm } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class RegepTechnicalResourceService {
  private eegEnergyProducers = new BehaviorSubject<EegEnergyProducer[]>([]);
  private formState = new BehaviorSubject<FormGroup>(null);

  constructor() {}

  setEegEnergyProducers(data: any) {
    this.eegEnergyProducers.next(data);
  }

  setFormState(data: FormGroup) {
    this.formState.next(data);
  }

  getEegEnergyProducers() {
    return this.eegEnergyProducers.asObservable();
  }

  getFormState() {
    return this.formState.asObservable();
  }
}
